import React, {useEffect, useContext} from "react";
import ScrollToTop from 'react-scroll-up';
import Particles from "react-tsparticles";
import { ProgressBar } from 'react-bootstrap';
import Header from "../component/header/Header";
import Footer from "../component/footer/Footer";
import Helmet from "../component/common/Helmet";

import {
    FaReact,
    FaShopify,
    FaSass
} from "react-icons/fa";
import {
    FiSmartphone,
    FiCode,
    FiDownload,
    FiCommand,
    FiHeadphones,
    FiChevronUp
} from "react-icons/fi";
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemPanel,
    AccordionItemButton,
} from 'react-accessible-accordion';
// Demo styles, see 'Styles' section below for some notes on use.
import 'react-accessible-accordion/dist/fancy-example.css';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { LanguageContext } from '../context/LanguageContext';
import translations from '../translations';


const featureList = [
    {
        icon: <FaReact/>,
        title: 'Modern JS UI frameworks',
        subtitle: 'We specialize in React, Vue, and Next.js, delivering exceptional web applications and user experiences..'
    },
    {
        icon: <FiSmartphone/>,
        title: 'Perfect Responsive',
        subtitle: 'We specialize in responsive web design, crafting visually stunning websites for all devices..'
    },
    {
        icon: <FiCode/>,
        title: 'No SQl ',
        subtitle: 'We specialize in developing with NoSQL databases, powering scalable and efficient data solutions.'
    },
    {
        icon: <FaSass/>,
        title: 'RTL CSS ',
        subtitle: 'We specialize in developing the best RTL CSS for seamless right-to-left language support.'
    },
    {
        icon: <FiDownload/>,
        title: 'Arabic UX',
        subtitle: 'We are Arabic UXers, creating exceptional user experiences tailored for the Arab world. '
    },
    {
        icon: <FiCommand/>,
        title: 'Modern Design',
        subtitle: 'We specialize in developing modern designs that are visually captivating and innovative.'
    },
    {
        icon: <FiHeadphones/>,
        title: '24 Support System',
        subtitle: 'We are provide 24 hours support for all clients.'
    },
    {
        icon: <FaShopify/>,
        title: 'CMS shopify',
        subtitle: 'We specialize in creating Shopify stores, delivering seamless e-commerce experiences for businesses.'
    }
]

const singleDemo = [
    {
        url: 'https://mass-portal.com/',
        imageUrl: 'dark-main-demo.png',
        title: 'MassPortal',
        description: 'MassPortal Arabic Taxation Portal: Your comprehensive online platform for simplified and efficient Arabic taxation management..',
        label: 'Fintech'
    },
    {
        url: 'https://mass-billing.web.app/',
        imageUrl: 'massbilling-480x470.png',
        title: 'MassBill',
        description: 'MassBill Arabic ERP System: Streamline your business operations with our powerful and user-friendly Arabic Enterprise Resource Planning solution..',
        label: 'Fintech'
    },
     {
        url: 'https://mass-contracts.web.app/mc-intro',
        imageUrl: 'mass-contractsj-480x470.png',
        title: "Mass Contracts",
        description: "Mass Contracts: Smart contract and agreement management platform.",
        label: 'Fintech'
    },
    {
        url: 'https://massbill-hasibat.web.app/',
        imageUrl: 'masshasibat-480x470.png',
        title: 'Mass Hasibat',
        description: 'Hasibat Arabic Free Financial Calculators: Empowering you with a suite of convenient and reliable Arabic financial calculators..',
        label: 'Fintech'
    },
    {
        url: 'https://fintrack.expert/',
        imageUrl: 'fintrack-480x470.png',
        title: 'Fintrack',
        description: 'Fintrack: Designed for professionals and accessible to everyone. Check your salary statements, retirement funds, and all your financial data.',
        label: 'Fintech'
    },
    {
        url: 'https://massaii.web.app/',
        imageUrl: 'massai-480x470.png',
        title: 'MassAi',
        description: 'MassAi Arabic Free AI Image Creation: Unleash your creativity with our cutting-edge AI-powered image creation tools in Arabic..',
        label: 'AI'
    },
       {
        url: 'https://massbook.co/',
        imageUrl: 'massbook-480x470.png',
        title: "MassBook",
        description: "MassBook: Social networking and community platform.",
        label: 'Social Media'
    },
    {
        url: 'https://levaant.web.app/',
        imageUrl: 'levant-480x470.png',
        title: 'Levant',
        description: 'Levant: AI-powered social media for healthcare, connecting professionals and empowering patients in a digital community..',
        label: 'AI'
    },
    {
        // url: 'https://massres.work/',
        url: 'https://mass-res.web.app/',
        imageUrl: 'massRess-480x470.png',
        title: 'Massres',
        description: 'MassRes: The social media platform connecting freelancers and job seekers in the pursuit of opportunities..',
        label: 'Social Media'
    },

    {
        // url: 'https://math-ac2.firebaseapp.com/',
        url: 'https://math-ac.com/',
        imageUrl: 'mathac-480x470.png',
        title: 'Math Academy',
        description: 'Math Academy: Unlock the world of web coding through our comprehensive and interactive online courses..',
        label: 'Commercial'
    },

    {
        url: 'https://earthsense-morroco-dev.web.app/earthsense/',
        imageUrl: 'earthsense-480x470.png',
        title: 'Earth Sense',
        description: 'EarthSense: Your trusted agricultural consulting partner in Morocco, providing expertise and solutions for sustainable farming..',
        label: 'Commercial'
    },

    {
        url: 'https://agrima-dev.web.app/',
        imageUrl: 'agrima-480x470.png',
        title: 'Agrima',
        description: 'Agrima: A leading enterprise holding company, driving growth and innovation across diverse industries..',
        label: 'Commercial'
    },
    {
        url: 'https://bostani-me.web.app/',
        imageUrl: 'bostani-480x470.png',
        title: 'Bostani',
        description: 'Bostani: The social media platform connecting agriculture enthusiasts, fostering knowledge sharing and community engagement.',
        label: 'Social Media'
    },
    {
        url: 'https://massarwe.com/',
        imageUrl: 'massarweh-480x470.png',
        title: 'Massarwe',
        description: 'Massarwe: Empowering businesses with cutting-edge fintech consulting services for strategic growth and financial innovation..',
        label: 'Fintech'
    },
    {
        url: 'https://mass-dev-cs.web.app/',
        imageUrl: 'massdev-480x470.png',
        title: 'MassDev- Arabic',
        description: 'MassDev: Your one-stop destination for professional website development services, delivering stunning and functional online experiences..',
        label: 'Commercial'
    },
    {
        url: 'https://zayn-steak-and-grillshow.web.app/index.html',
        imageUrl: 'zains-480x740.png',
        title: "ZAYN'S",
        description: "'Zayn's creates dishes full of flavor, we pride ourselves on using fresh, sustainable ingredients in new and delectable ways.",
        label: 'Commercial'
    },

    {
        url: 'https://omrimassarwe.com/',
        imageUrl: 'omri-480x470.png',
        title: "Omri Massarwe",
        description: "Photographer & Filmmaker Based In Jerusalem.",
        label: 'Commercial'
    },
    {
        url: 'https://omricore.com/',
        imageUrl: 'omricore-480x470.png',
        title: "OmriCore",
        description: "OmriCore is a visual storytelling agency rooted in a decade of experience, purpose, and passion.",
        label: 'Commercial'
    },
    {
        url: 'https://vivmana.com/',
        imageUrl: 'vivmana-480x470.png',
        title: "VIVMANA",
        description: "VIVMANA: Premium beauty and cosmetic products and services designed to enhance your natural beauty and boost your confidence.",
        label: 'Commercial'
    },
    {
        url: 'https://almihaniyoun-pro.web.app/',
        imageUrl: 'almihaniyoun-480x470.png',
        title: "Bunat",
        description: "Bunat: Professional services and solutions for your business needs.",
        label: 'Commercial'
    },
    {
        url: 'https://albushra-ai.web.app/',
        imageUrl: 'albushra-480x470.png',
        title: "Al Bushra AI",
        description: "Al Bushra AI: Innovative AI-powered solutions for modern businesses.",
        label: 'AI'
    },
    {
        url: 'https://immobilier-ndjamena.web.app/',
        imageUrl: 'immobilier-ndjamena-480x470.png',
        title: "Immobilier N'Djamena",
        description: "Immobilier N'Djamena: Real estate solutions and property management services.",
        label: 'Commercial'
    },
    {
        url: 'https://mass-tec.web.app/',
        imageUrl: 'mass-tec-480x470.png',
        title: "Mass Tec",
        description: "Mass Tec: Technology solutions and digital transformation services.",
        label: 'Commercial'
    },

    {
        url: 'https://muqadimah-ibenkhaldoun.web.app/',
        imageUrl: 'muqadimah-ibenkhaldoun-480x470.png',
        title: "Muqadimah Ibn Khaldoun",
        description: "Muqadimah Ibn Khaldoun: Educational and cultural platform.",
        label: 'Commercial'
    },
    {
        url: 'https://wahy-alqalam.web.app/',
        imageUrl: 'wahy-alqalam-480x470.png',
        title: "Wahy Al Qalam",
        description: "Wahy Al Qalam: Creative writing and literary platform.",
        label: 'Commercial'
    },
    {
        url: 'https://alnaqdan.com/',
        imageUrl: 'alnaqdan-480x470.png',
        title: "Al Naqdan",
        description: "Al Naqdan: Financial and economic insights platform.",
        label: 'Fintech'
    },
    {
        url: 'https://caraj-dev.firebaseapp.com/pages/login',
        imageUrl: 'caraj-480x470.png',
        title: "Caraj",
        description: "Caraj: Comprehensive management and logistics platform.",
        label: 'Fintech'
    },
    {
        url: 'https://universal-interface.co',
        imageUrl: 'universal-interfacej-480x470.png',
        title: "Universal Interface",
        description: "Universal Interface: Advanced interface solutions for modern applications.",
        label: 'Commercial'
    },
    // {
    //     url: "https://motken-ai.web.app/",
    //    imageUrl: 'Screenshot 2025-12-25 162307.png',
    //     title: "Motken AI",
    //     description: "احصل على نسخ مفرغة دقيقة لفيديوهات يوتيوب وتيك توك باللغة العربية باستخدام أحدث تقنيات الذكاء الاصطناعي.",
    //     label: 'Commercial'
    // },
    // {
    //     url: '#',
    //     imageUrl: 'dokanji-480x470.png',
    //     title: "Dokamji",
    //     description: "Dokamji: Coming soon.",
    //     label: 'Commercial'
    // },
   
    {
        url: 'https://juabeh-hospital.web.app/',
        imageUrl: 'juabeh-hospital-480x470.png',
        title: "Juabeh Hospital",
        description: "Juabeh Hospital: Healthcare management and patient services platform.",
        label: 'Commercial'
    },
    {
        url: 'https://fadi-dahabreh.web.app/',
        imageUrl: 'fadi-dahabreh-480x470.png',
        title: "Fadi Dahabreh",
        description: "Fadi Dahabreh: Professional portfolio and services platform.",
        label: 'Commercial'
    },
    {
        url: 'https://subhicuts-dev.web.app/',
        imageUrl: 'subhicuts-480x470.png',
        title: "Subhi Cuts",
        description: "Subhi Cuts: Professional grooming and styling services.",
        label: 'Commercial'
    },
      {
        url: 'https://edu-mass.web.app/',
        imageUrl: 'edumass-480x470.png',
        title: "EduMass",
        description: "منصة التعليم الذكية المدعومة بالذكاء الاصطناعي لمساعدة المعلمين في إنشاء المحتوى التعليمي، وتخطيط الدروس، وإنشاء الاختبارات، وأكثر من ذلك بكثير.",
        label: 'AI'
    },{
        url: 'https://mass-prtg.web.app/',
        imageUrl: 'mass-prtg-480x470.png',
        title: "Mass-Prtg",
        description: "PRTGMass is an intelligent React-based platform that connects seamlessly with PRTG Network Monitor to collect, analyze, and visualize network performance data in real time.",
        label: 'Fintech'
    },
   {
        url: 'https://motken-ai.web.app/',
        imageUrl: 'mutken-480x470.png',
        title: "Motken AI",
        description: "احصل على نسخ مفرغة دقيقة لفيديوهات يوتيوب وتيك توك باللغة العربية باستخدام أحدث تقنيات الذكاء الاصطناعي.",
        label: 'AI'
    },
    {
        url: 'https://mass-quickscan.web.app/',
        imageUrl: 'quickscan-480x470.png',
        title: 'Quick Scan',
        description: 'يمكنك فحص أي باركود من خلال ادخال المعلومات: نص أو رقم',
        label: 'Commercial'
    },
    {
        url: 'https://mass-prj.web.app/',
        imageUrl: 'mass-prj-480x470.png',
        title: 'Mass Project',
        description: 'MassProject',
        label: 'Fintech'
    },
 {
        url: 'https://api-massarwe.web.app/',
        imageUrl: 'api-massarwe-480x470.png',
        title: 'Api.massarwe',
        description: 'This portal grants you access to Massarwe APIs — simple, secure, and powerful. Interface with the digital realm through our quantum-encrypted data channels.',
        label: 'Commercial'
    },
 
    // {
    //     url: '#',
    //     imageUrl: 'mirath-480x470.png',
    //     title: "Mirath",
    //     description: "Mirath: Coming soon.",
    //     label: 'Commercial'
    // },


   
]

const agencyDemo = [
    {
        url: 'https://mass-portal.com/',
        imageUrl: 'dark-main-demo.png',
        title: 'MassPortal',
        description: 'MassPortal Arabic Taxation Portal: Your comprehensive online platform for simplified and efficient Arabic taxation management..',
        label: 'Fintech'
    },
    {
        url: 'https://mass-billing.web.app/',
        imageUrl: 'massbilling-480x470.png',
        title: 'MassBill',
        description: 'MassBill Arabic ERP System: Streamline your business operations with our powerful and user-friendly Arabic Enterprise Resource Planning solution..',
        label: 'Fintech'
    },
    {
        url: 'https://mass-contracts.web.app/mc-intro',
        imageUrl: 'mass-contractsj-480x470.png',
        title: "Mass Contracts",
        description: "Mass Contracts: Smart contract and agreement management platform.",
        label: 'Fintech'
    },
    {
        url: 'https://massbill-hasibat.web.app/',
        imageUrl: 'masshasibat-480x470.png',
        title: 'Mass Hasibat',
        description: 'Hasibat Arabic Free Financial Calculators: Empowering you with a suite of convenient and reliable Arabic financial calculators..',
        label: 'Fintech'
    },
    {
        url: 'https://fintrack.expert/',
        imageUrl: 'fintrack-480x470.png',
        title: 'Fintrack',
        description: 'Fintrack: Designed for professionals and accessible to everyone. Check your salary statements, retirement funds, and all your financial data.',
        label: 'Fintech'
    },
    {
        url: 'https://massarwe.com/',
        imageUrl: 'massarweh-480x470.png',
        title: 'Massarwe',
        description: 'Massarwe: Empowering businesses with cutting-edge fintech consulting services for strategic growth and financial innovation..',
        label: 'Fintech'
    },
    {
        url: 'https://alnaqdan.com/',
        imageUrl: 'alnaqdan-480x470.png',
        title: "Al Naqdan",
        description: "Al Naqdan: Financial and economic insights platform.",
        label: 'Fintech'
    },
    {
        url: 'https://caraj-dev.firebaseapp.com/pages/login',
        imageUrl: 'caraj-480x470.png',
        title: "Caraj",
        description: "Caraj: Comprehensive management and logistics platform.",
        label: 'Fintech'
    },
    {
        url: 'https://mass-prtg.web.app/',
        imageUrl: 'mass-prtg-480x470.png',
        title: "Mass-Prtg",
        description: "PRTGMass is an intelligent React-based platform that connects seamlessly with PRTG Network Monitor to collect, analyze, and visualize network performance data in real time.",
        label: 'Fintech'
    },
    {
        url: 'https://mass-prj.web.app/',
        imageUrl: 'mass-prj-480x470.png',
        title: 'Mass Project',
        description: 'MassProject',
        label: 'Fintech'
    },
]

const busenessDemo = [
    {
        url: 'https://massbook.co/',
        imageUrl: 'massbook-480x470.png',
        title: "MassBook",
        description: "MassBook: Social networking and community platform.",
        label: 'Social Media'
    },
    {
        url: 'https://mass-res.web.app/',
        imageUrl: 'massRess-480x470.png',
        title: 'Massres',
        description: 'MassRes: The social media platform connecting freelancers and job seekers in the pursuit of opportunities..',
        label: 'Social Media'
    },
    {
        url: 'https://bostani-me.web.app/',
        imageUrl: 'bostani-480x470.png',
        title: 'Bostani',
        description: 'Bostani: The social media platform connecting agriculture enthusiasts, fostering knowledge sharing and community engagement.',
        label: 'Social Media'
    },
]

const portfolioList = [
    {
        url: 'https://math-ac.com/',
        imageUrl: 'mathac-480x470.png',
        title: 'Math Academy',
        description: 'Math Academy: Unlock the world of web coding through our comprehensive and interactive online courses..',
        label: 'Commercial'
    },
    {
        url: 'https://earthsense-morroco-dev.web.app/earthsense/',
        imageUrl: 'earthsense-480x470.png',
        title: 'Earth Sense',
        description: 'EarthSense: Your trusted agricultural consulting partner in Morocco, providing expertise and solutions for sustainable farming..',
        label: 'Commercial'
    },
    {
        url: 'https://agrima-dev.web.app/',
        imageUrl: 'agrima-480x470.png',
        title: 'Agrima',
        description: 'Agrima: A leading enterprise holding company, driving growth and innovation across diverse industries..',
        label: 'Commercial'
    },
    {
        url: 'https://mass-dev.com/',
        imageUrl: 'massdev-480x470.png',
        title: 'MassDev- Arabic',
        description: 'MassDev: Your one-stop destination for professional website development services, delivering stunning and functional online experiences..',
        label: 'Commercial'
    },
    {
        url: 'https://zayn-steak-and-grillshow.web.app/index.html',
        imageUrl: 'zains-480x740.png',
        title: "ZAYN'S",
        description: "'Zayn's creates dishes full of flavor, we pride ourselves on using fresh, sustainable ingredients in new and delectable ways.",
        label: 'Commercial'
    },
    {
        url: 'https://omrimassarwe.com/',
        imageUrl: 'omri-480x470.png',
        title: "Omri Massarwe",
        description: "Photographer & Filmmaker Based In Jerusalem.",
        label: 'Commercial'
    },
    {
        url: 'https://omricore.com/',
        imageUrl: 'omricore-480x470.png',
        title: "OmriCore",
        description: "OmriCore is a visual storytelling agency rooted in a decade of experience, purpose, and passion.",
        label: 'Commercial'
    },
    {
        url: 'https://vivmana.com/',
        imageUrl: 'vivmana-480x470.png',
        title: "VIVMANA",
        description: "VIVMANA: Premium beauty and cosmetic products and services designed to enhance your natural beauty and boost your confidence.",
        label: 'Commercial'
    },
    {
        url: 'https://almihaniyoun-pro.web.app/',
        imageUrl: 'almihaniyoun-480x470.png',
        title: "Bunat",
        description: "Bunat: Professional services and solutions for your business needs.",
        label: 'Commercial'
    },
    {
        url: 'https://immobilier-ndjamena.web.app/',
        imageUrl: 'immobilier-ndjamena-480x470.png',
        title: "Immobilier N'Djamena",
        description: "Immobilier N'Djamena: Real estate solutions and property management services.",
        label: 'Commercial'
    },
    {
        url: 'https://mass-tec.web.app/',
        imageUrl: 'mass-tec-480x470.png',
        title: "Mass Tec",
        description: "Mass Tec: Technology solutions and digital transformation services.",
        label: 'Commercial'
    },
    {
        url: 'https://muqadimah-ibenkhaldoun.web.app/',
        imageUrl: 'muqadimah-ibenkhaldoun-480x470.png',
        title: "Muqadimah Ibn Khaldoun",
        description: "Muqadimah Ibn Khaldoun: Educational and cultural platform.",
        label: 'Commercial'
    },
    {
        url: 'https://wahy-alqalam.web.app/',
        imageUrl: 'wahy-alqalam-480x470.png',
        title: "Wahy Al Qalam",
        description: "Wahy Al Qalam: Creative writing and literary platform.",
        label: 'Commercial'
    },
    {
        url: 'https://universal-interface.co',
        imageUrl: 'universal-interfacej-480x470.png',
        title: "Universal Interface",
        description: "Universal Interface: Advanced interface solutions for modern applications.",
        label: 'Commercial'
    },
    {
        url: 'https://juabeh-hospital.web.app/',
        imageUrl: 'juabeh-hospital-480x470.png',
        title: "Juabeh Hospital",
        description: "Juabeh Hospital: Healthcare management and patient services platform.",
        label: 'Commercial'
    },
    {
        url: 'https://fadi-dahabreh.web.app/',
        imageUrl: 'fadi-dahabreh-480x470.png',
        title: "Fadi Dahabreh",
        description: "Fadi Dahabreh: Professional portfolio and services platform.",
        label: 'Commercial'
    },
    {
        url: 'https://subhicuts-dev.web.app/',
        imageUrl: 'subhicuts-480x470.png',
        title: "Subhi Cuts",
        description: "Subhi Cuts: Professional grooming and styling services.",
        label: 'Commercial'
    },
    {
        url: 'https://mass-quickscan.web.app/',
        imageUrl: 'quickscan-480x470.png',
        title: 'Quick Scan',
        description: 'يمكنك فحص أي باركود من خلال ادخال المعلومات: نص أو رقم',
        label: 'Commercial'
    },
    {
        url: 'https://api-massarwe.web.app/',
        imageUrl: 'api-massarwe-480x470.png',
        title: 'Api.massarwe',
        description: 'This portal grants you access to Massarwe APIs — simple, secure, and powerful. Interface with the digital realm through our quantum-encrypted data channels.',
        label: 'Commercial'
    },
]

const landingPage = [
    {
        url: 'dark-portfolio-landing',
        imageUrl: 'dark-personal-portfolio-landing.png',
        title: 'Personal Portfolio 02 — One Page',
        description: 'It comes with landing page feature. This tamplate you can be used for your Personal useses,  Freelancer, Designer, and Developer etc.',
        label: 'Hot'
    },
    {
        url: 'portfolio-landing',
        imageUrl: 'personal-portfolio-landing.png',
        title: 'Personal Portfolio — One Page',
        description: 'It comes with landing page feature. This tamplate you can be used for your Personal useses,  Freelancer, Designer, and Developer etc.',
        label: 'New'
    },
    {
        url: 'creative-landing',
        imageUrl: 'creative-landing.png',
        title: 'Creative Agency 02 — One Page',
        description: 'Added creative agency landing page.When you need creative agency landing page you can be use it for your creative agency, Digital agency landing page page.',
        label: 'New'
    },
    {
        url: 'interior-landing',
        imageUrl: 'interior-design.png',
        title: 'Interior Design',
        description: 'A interior design comes for new interior agency company. Our can hire your clint by using this template. It has landing page feature available.',
        label: 'New'
    },
    {
        url: 'home-particles',
        imageUrl: 'homeparticles.png',
        title: 'Home Particle — Landing Page',
        description: 'Home particle has most feature is particles animation.It can be used for your creative agency, Business agency, Digital agency and so on, And it has Landing page added.',
        label: ''
    },
]

const newDemoList = [
    {
        url: 'https://massaii.web.app/',
        imageUrl: 'massai-480x470.png',
        title: 'MassAi',
        description: 'MassAi Arabic Free AI Image Creation: Unleash your creativity with our cutting-edge AI-powered image creation tools in Arabic..',
        label: 'AI'
    },
    {
        url: 'https://levaant.web.app/',
        imageUrl: 'levant-480x470.png',
        title: 'Levant',
        description: 'Levant: AI-powered social media for healthcare, connecting professionals and empowering patients in a digital community..',
        label: 'AI'
    },
    {
        url: 'https://albushra-ai.web.app/',
        imageUrl: 'albushra-480x470.png',
        title: "Al Bushra AI",
        description: "Al Bushra AI: Innovative AI-powered solutions for modern businesses.",
        label: 'AI'
    },
    {
        url: 'https://edu-mass.web.app/',
        imageUrl: 'edumass-480x470.png',
        title: "EduMass",
        description: "منصة التعليم الذكية المدعومة بالذكاء الاصطناعي لمساعدة المعلمين في إنشاء المحتوى التعليمي، وتخطيط الدروس، وإنشاء الاختبارات، وأكثر من ذلك بكثير.",
        label: 'AI'
    },
    {
        url: 'https://motken-ai.web.app/',
        imageUrl: 'mutken-480x470.png',
        title: "Motken AI",
        description: "احصل على نسخ مفرغة دقيقة لفيديوهات يوتيوب وتيك توك باللغة العربية باستخدام أحدث تقنيات الذكاء الاصطناعي.",
        label: 'AI'
    },
]

const innerDemo = [
    {
        url: 'service',
        imageUrl: 'service.png',
        title: 'Service',
    },
    {
        url: 'service-details',
        imageUrl: 'service-details.png',
        title: 'Service Details',
    },
    {
        url: 'about',
        imageUrl: 'about.png',
        title: 'About',
    },
    {
        url: 'blog',
        imageUrl: 'blog-list.png',
        title: 'Blog List',
    },
    {
        url: 'blog-details',
        imageUrl: 'blog-details.png',
        title: 'Blog Details',
    },
    {
        url: 'portfolio',
        imageUrl: 'portfolio.png',
        title: 'Portfolio',
    },
    {
        url: 'portfolio-details',
        imageUrl: 'portfolio-details.png',
        title: 'Portfolio Details',
    },
    {
        url: 'contact',
        imageUrl: 'contact.png',
        title: 'Contact',
    },
    {
        url: '404',
        imageUrl: '404.png',
        title: '404 Page',
    },

]

export default function () {
//   to add arabic font to the arabic content
        const info = React.createRef();
        const { language } = useContext(LanguageContext);
        const t = translations[language];

        useEffect(() => {
            // Check if the paragraph content contains Arabic characters
            const hasArabic = /[\u0600-\u06FF]/.test(info.current.textContent);

            // Add a CSS class based on the result
            if (hasArabic) {
                info.current.classList.add('arabic-text');
            } else {
                info.current.classList.add('non-arabic-text');
            }
          }, []);

        return (
            <div className="active-dark">
                <Helmet pageTitle="MassDev - Our Projects & Portfolio" />
                <Header headertransparent="header--static" colorblack="color--black" logoname="logo.png" />

                {/* Start Banner Area  */}
                <div className="prv-banner-wrapper"
                     style={{backgroundImage: `url("assets/images/preview/preview-bg.jpg")`}}>
                    <div className="container-fluid">
                        <div className="plr--120">
                            <div className={language === "ar" ? "row flex-row-reverse" : "row"}>
                                <div className="col-lg-8 col-xl-5">
                                    <div className="inner">
                                        {/* <div className={language === "ar" ? "logo logo-right": "logo text-left"}>
                                            <a href="/">
                                                <img src="/assets/images/logo/logo-all-dark.png"  alt="MassDEV"/>
                                            </a>
                                        </div> */}
                                        <p className="title text-center ">{t.demo.banner.title}</p>
                                        <div className="purshase-btn">
                                            <a href="creative-agency" target="_blank" className="rn-button-style--2 btn-solid">{t.demo.banner.exploreButton}</a>
                                            {/* <a href="https://mass-dev.com/" target='_blank' className="rn-button-style--2 btn-border rn-btn-dark border-opacity-half">{t.demo.banner.arabicButton}</a> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* <div className="fullscreen empty-div gradient-overlay"></div> */}
                {/* End Banner Area  */}

                {/* Start Preview Main Wrapper */}
                <div className="main-wrapper" id="demo">

                    {/* Start Main Demo Area  */}
                    <div className="home-demo-area bg_color--5 ptb--120">
                        <div className="wrapper plr--120">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="section-title text-center pb--30">
                                        <h2 className="theme-gradient ">{t.demo.projects.welcome}</h2>
                                        <p className="rn-text-white">{t.demo.projects.subtitle}</p>
                                    </div>
                                </div>
                            </div>
                            <Tabs>
                                <div className="row text-center">
                                    <div className="col-lg-12">
                                        <div className="tablist-inner">
                                            <TabList className="pv-tab-button text-center">
                                                <Tab><span>{t.demo.projects.tabs.all}</span></Tab>
                                                <Tab><span>{t.demo.projects.tabs.fintech}</span></Tab>
                                                <Tab><span>{t.demo.projects.tabs.social}</span></Tab>
                                                <Tab><span>{t.demo.projects.tabs.commercial}</span></Tab>
                                                {/* <Tab><span>Landing</span></Tab> */}
                                                <Tab><span>{t.demo.projects.tabs.ai}</span></Tab>
                                            </TabList>
                                        </div>
                                    </div>
                                </div>

                                {/* Scrollable Projects Container */}
                                <div className="projects-scroll-container">
                                <TabPanel className="row">
                                    {singleDemo.map((value , index) => (
                                        // Start Single Demo 
                                        <div key={index} className="col-lg-4 col-md-6 col-sm-6 col-12">
                                            <div className="single-demo">
                                                <a target="_blank" rel="noopener noreferrer" href={`${value.url} `}>
                                                    <img src={`/assets/images/preview/${value.imageUrl}`} alt="Creative MassDev Images"/>
                                                    <h3 className="title">{value.title}</h3>
                                                    <p className="info" ref={info}>{value.description}</p>
                                                    {value.label ? <div className="label-new"><span>{value.label}</span></div> : ''}
                                                </a>
                                            </div>
                                        </div>
                                        // End Single Demo
                                    ))}
                                </TabPanel>

                                <TabPanel className="row">
                                    {agencyDemo.map((value , index) => (
                                        // Start Single Demo 
                                        <div key={index} className="col-lg-4 col-md-6 col-sm-6 col-12">
                                            <div className="single-demo">
                                                <a target="_blank" rel="noopener noreferrer" href={`${value.url} `}>
                                                    <img src={`/assets/images/preview/${value.imageUrl}`} alt="Creative MassDev Images"/>
                                                    <h3 className="title">{value.title}</h3>
                                                    <p className="info">{value.description}</p>
                                                    {value.label ? <div className="label-new"><span>{value.label}</span></div> : ''}
                                                </a>
                                            </div>
                                        </div>
                                        // End Single Demo
                                    ))}
                                </TabPanel>

                                <TabPanel className="row">
                                    {busenessDemo.map((value , index) => (
                                        // Start Single Demo 
                                        <div key={index} className="col-lg-4 col-md-6 col-sm-6 col-12">
                                            <div className="single-demo">
                                                <a target="_blank" rel="noopener noreferrer" href={`/${value.url} `}>
                                                    <img src={`/assets/images/preview/${value.imageUrl}`} alt="Creative Agency Images"/>
                                                    <h3 className="title">{value.title}</h3>
                                                    <p className="info">{value.description}</p>
                                                    {value.label ? <div className="label-new"><span>{value.label}</span></div> : ''}
                                                </a>
                                            </div>
                                        </div>
                                        // End Single Demo
                                    ))}
                                </TabPanel>

                                <TabPanel className="row">
                                    {portfolioList.map((value , index) => (
                                        // Start Single Demo 
                                        <div key={index} className="col-lg-4 col-md-6 col-sm-6 col-12">
                                            <div className="single-demo">
                                                <a target="_blank" rel="noopener noreferrer" href={`/${value.url} `}>
                                                    <img src={`/assets/images/preview/${value.imageUrl}`} alt="Creative Agency Images"/>
                                                    <h3 className="title">{value.title}</h3>
                                                    <p className="info">{value.description}</p>
                                                    {value.label ? <div className="label-new"><span>{value.label}</span></div> : ''}
                                                </a>
                                            </div>
                                        </div>
                                        // End Single Demo
                                    ))}
                                </TabPanel>

                                {/* <TabPanel className="row">
                                    {landingPage.map((value , index) => (
                                        // Start Single Demo 
                                        <div key={index} className="col-lg-4 col-md-6 col-sm-6 col-12">
                                            <div className="single-demo">
                                                <a target="_blank" rel="noopener noreferrer" href={`/${value.url} `}>
                                                    <img src={`/assets/images/preview/${value.imageUrl}`} alt="Creative Agency Images"/>
                                                    <h3 className="title">{value.title}</h3>
                                                    <p className="info">{value.description}</p>
                                                    {value.label ? <div className="label-new"><span>{value.label}</span></div> : ''}
                                                </a>
                                            </div>
                                        </div>
                                        // End Single Demo
                                    ))}
                                </TabPanel> */}

                                <TabPanel className="row">
                                    {newDemoList.map((value , index) => (
                                        // Start Single Demo 
                                        <div key={index} className="col-lg-4 col-md-6 col-sm-6 col-12">
                                            <div className="single-demo">
                                                <a target="_blank" rel="noopener noreferrer" href={`/${value.url} `}>
                                                    <img src={`/assets/images/preview/${value.imageUrl}`} alt="Creative Agency Images"/>
                                                    <h3 className="title">{value.title}</h3>
                                                    <p className="info">{value.description}</p>
                                                    {value.label ? <div className="label-new"><span>{value.label}</span></div> : ''}
                                                </a>
                                            </div>
                                        </div>
                                        // End Single Demo
                                    ))}
                                </TabPanel>
                                </div>
                                {/* End Scrollable Projects Container */}

                            </Tabs>

                        </div>
                    </div>
                    {/* End Main Demo Area  */}

                    {/* Start Feature Area  */}
                    <div className="prv-feature service-area  ptb--120">
                        <div className="wrapper plr--120">

                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="section-title text-center pb--30 pb_sm--0 pb_md--0">
                                        <h2 className="theme-gradient"><span>{t.demo.tools.title}</span></h2>
                                        <p className="rn-text-black">{t.demo.tools.description}</p>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                {/* Start Single Feature  */}
                                {t.demo.tools.features.map((feature, i) => (
                                    <div className="col-lg-6 col-xl-3 col-md-6 col-sm-6 col-12 mt--30" key={i}>
                                        <div className="service service__style--4">
                                            <div className="icon">
                                                {featureList[i].icon}
                                            </div>
                                            <div className="content">
                                                <h3 className="title">{feature.title}</h3>
                                                <p className="subtitle">{feature.description}</p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                                {/* End Single Feature  */}
                            </div>
                            
                        </div>
                    </div>
                    {/* End Feature Area  */}

                    <div className="gt-matrik-score-area ptb--120 bg_color--5">
                        <div className="container">
                            <div className="row row--35">

                                <div className={language === "ar" ? "col-lg-6 col-md-12 col-12 text-left" : "col-lg-6 col-md-12 col-12"} >
                                    <div className="inner">
                                        <h2 className="title theme-gradient">{t.demo.performance.title}</h2>
                                        <p className="rn-text-white">{t.demo.performance.description}</p>
                                    </div>
                                </div>

                                <div className="col-lg-6 col-md-12 col-12 mt_md--40 mt_sm--40">
                                    <div className="progress-wrapper">
                                        <h3 className={language === "ar" ? "text-left" : "heading"} >{t.demo.performance.gtmetrixTitle}</h3>
                                        <div className="rn-progress-bar progress-bar--3 large-bar">
                                            <div className="single-progress">
                                                <h6 className="title">{t.demo.performance.metrics.pageSpeed}</h6>
                                                <ProgressBar className="rounded" now={100} />
                                                <span className="label">100%</span>
                                            </div>

                                            <div className="single-progress">
                                                <h6 className="title">{t.demo.performance.metrics.yslow}</h6>
                                                <ProgressBar now={100} />
                                                <span className="label">100%</span>
                                            </div>

                                            <div className="single-progress">
                                                <h6 className="title">{t.demo.performance.metrics.fullyLoaded}</h6>
                                                <ProgressBar now={100} />
                                                <span className="label">100%</span>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        {/* <div className="shape-images">
                            <img src="/assets/images/icons/wave-icon.png" alt="Wave Images" />
                        </div> */}
                    </div>

                    {/* Start Responsive Device Area  */}
                    <div className="responsive-device-area  bg_image bg_image--34 ">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12 col-xl-6 offset-xl-6">
                                    <div className="inner">
                                        <div className="section-title">
                                            <h2 className="title theme-gradient">{t.demo.responsive.title}</h2>
                                            <p className="rn-text-white">{t.demo.responsive.description}</p>
                                        </div>
                                        <div className="responsive-layout-mokup">
                                            <div className="mokup-list">
                                                <div className="icon">
                                                    <img src="/assets/images/icons/phone.png" alt="icon Images" />
                                                </div>
                                                <h6>{t.demo.responsive.devices.phone}</h6>
                                            </div>
                                            <div className="mokup-list">
                                                <div className="icon">
                                                    <img src="/assets/images/icons/tablet.png" alt="icon Images" />
                                                </div>
                                                <h6>{t.demo.responsive.devices.tablet}</h6>
                                            </div>
                                            <div className="mokup-list">
                                                <div className="icon">
                                                    <img src="/assets/images/icons/desktop.png" alt="icon Images" />
                                                </div>
                                                <h6>{t.demo.responsive.devices.desktop}</h6>
                                            </div>
                                        </div>
                                        <p className="subtitle rn-text-white">{t.demo.responsive.subtitle}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* End Responsive Device Area  */}

                     {/* Start Faq Area */}
                    <div className="rn-accordion-area pv-feaq-area bg_color--5 ptb--120 mt ">
                        <div className="container">
                            <div className="row row--35">
                                <div className="col-lg-8 col-sm-12">
                                    <div className="section-title text-left mb--30">
                                        <h2 className="title">{t.demo.faq.title} <span className="theme-color">{t.demo.faq.titleHighlight}</span>
                                        </h2>
                                        <p className="rn-text-white">{t.demo.faq.description}</p>
                                    </div>
                                    <div className="faq-area">
                                        <Accordion className="accodion-style--1" preExpanded={'0'}>
                                            {t.demo.faq.questions.map((item, index) => (
                                                <AccordionItem key={index}>
                                                    <AccordionItemHeading>
                                                        <AccordionItemButton>
                                                            {item.question}
                                                        </AccordionItemButton>
                                                    </AccordionItemHeading>
                                                    <AccordionItemPanel>
                                                        <p>{item.answer}</p>
                                                    </AccordionItemPanel>
                                                </AccordionItem>
                                            ))}
                                        </Accordion>
                                    </div>
                                </div>

                                <div className="col-lg-4 col-sm-12 mt_md--40 mt_sm--40">
                                    <div className="card-box text-left">
                                        <div className="service">
                                            <div className="icon"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-book"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path></svg></div>
                                            <div className="content">
                                                <h3 className="title">{t.demo.faq.cta.title}</h3>
                                                <p>{t.demo.faq.cta.subtitle}</p>
                                                <a target="_blank" href="/contact" className="rbt-button rn-button-style--2 rn-btn-small-2 btn-solid-border"><span className="button-text">{t.demo.faq.cta.buttonText}</span></a>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="card-box text-left mt--40 support">
                                        <div className="service">
                                            <div className="icon">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-headphones"><path d="M3 18v-6a9 9 0 0 1 18 0v6"></path><path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z"></path></svg>
                                            </div>
                                            <div className="content">
                                                <h3 className="title">{t.demo.support.title}</h3>
                                                <p>{t.demo.support.description}</p>
                                                <a target="_blank" href="/contact" className="rbt-button rn-button-style--2 rn-btn-small-2 btn-solid-border"><span className="button-text">{t.demo.support.contactButton}</span></a>
                                                <ul className="liststyle">
                                                    <li><span>{t.demo.support.supportTime}</span> {t.demo.support.supportDays}</li>
                                                    <li><span>{t.demo.support.responseTime}</span> {t.demo.support.responseHours}</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>


                                </div>

                            </div>
                        </div>        
                    </div>
                     {/* Start Faq Area */}
                                    

                    


                    {/* <div className="testimonial-area bg_color--1 pt--120 pb--150 pt_md--80 pb_md--110 pt_sm--80 pb_sm--110">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="section-title text-center mb--30">
                                        <h2 className="title theme-gradient">Our Customer feedback</h2>
                                        <p>Our Fantastic Envato Customers Reviews</p>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12">
                                    <Slider className="mt--30 mt_sm--5 mt_md--5 testimonial-activation rn-slick-dot slick-gutter-15" {...testimonialActivation}>

                                        <div className="single-testimonial">
                                            <div className="pv-testimonial">
                                                <div className="inner">
                                                    <div className="inner-top">
                                                        <div className="thumbnail">
                                                            <img src="/assets/images/icons/download.png" alt="Download Images" />
                                                        </div>
                                                        <div className="info">
                                                            <h4 className="title">The4</h4>
                                                            <p>@The4</p>
                                                        </div>
                                                    </div>
                                                    <div className="content">
                                                        <h5>Design Quality</h5>
                                                        <p>The product is of good quality and easy to use, We are also the
                                                            author on Envato and our requirement is very high, Affordable
                                                            and excellent...</p>
                                                        <div className="rating">
                                                            <img src="/assets/images/icons/rating.png" alt="Rating Images" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                      
                                        <div className="single-testimonial">
                                            <div className="pv-testimonial">
                                                <div className="inner">
                                                    <div className="inner-top">
                                                        <div className="thumbnail">
                                                            <img src="/assets/images/icons/download.png" alt="Download Images" />
                                                        </div>
                                                        <div className="info">
                                                            <h4 className="title">wimm-x</h4>
                                                            <p>@wimm-x</p>
                                                        </div>
                                                    </div>
                                                    <div className="content">
                                                        <h5>Design Quality</h5>
                                                        <p>The configuration of the contact form was problematic, but the
                                                            support of
                                                            the Rainbow team helped a lot. That convinced me! Thanks!</p>
                                                        <div className="rating">
                                                            <img src="/assets/images/icons/rating.png" alt="Rating Images" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                       
                                        <div className="single-testimonial">
                                            <div className="pv-testimonial">
                                                <div className="inner">
                                                    <div className="inner-top">
                                                        <div className="thumbnail">
                                                            <img src="/assets/images/icons/download.png" alt="Download Images" />
                                                        </div>
                                                        <div className="info">
                                                            <h4 className="title">Cloudcapped</h4>
                                                            <p>@Cloudcapped</p>
                                                        </div>
                                                    </div>
                                                    <div className="content">
                                                        <h5>Customizability</h5>
                                                        <p>Excellent design template and easy to customize if you know
                                                            React. Good
                                                            value.</p>
                                                        <div className="rating">
                                                            <img src="/assets/images/icons/rating.png" alt="Rating Images" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                      
                                        <div className="single-testimonial">
                                            <div className="pv-testimonial">
                                                <div className="inner">
                                                    <div className="inner-top">
                                                        <div className="thumbnail">
                                                            <img src="/assets/images/icons/download.png" alt="Download Images" />
                                                        </div>
                                                        <div className="info">
                                                            <h4 className="title">piotrgrz</h4>
                                                            <p>@piotrgrz</p>
                                                        </div>
                                                    </div>
                                                    <div className="content">
                                                        <h5>Customer Support</h5>
                                                        <p>Perfectly support. Well deserved 5 star for code and design
                                                            quality.</p>
                                                        <div className="rating">
                                                            <img src="/assets/images/icons/rating.png" alt="Rating Images" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                               
                                        <div className="single-testimonial">
                                            <div className="pv-testimonial">
                                                <div className="inner">
                                                    <div className="inner-top">
                                                        <div className="thumbnail">
                                                            <img src="assets/images/icons/download.png" alt="Download Images" />
                                                        </div>
                                                        <div className="info">
                                                            <h4 className="title">xBoot</h4>
                                                            <p>@xBoot</p>
                                                        </div>
                                                    </div>
                                                    <div className="content">
                                                        <h5>Customer Support</h5>
                                                        <p>The best customer support I've ever received on Envato. The
                                                            author is absolutely great and he's always so fast to answer...
                                                        </p>
                                                        <div className="rating">
                                                            <img src="assets/images/icons/rating.png" alt="Rating Images" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                     
                                        <div className="single-testimonial">
                                            <div className="pv-testimonial">
                                                <div className="inner">
                                                    <div className="inner-top">
                                                        <div className="thumbnail">
                                                            <img src="assets/images/icons/download.png" alt="Download Images" />
                                                        </div>
                                                        <div className="info">
                                                            <h4 className="title">mindcycle001</h4>
                                                            <p>@mindcycle001</p>
                                                        </div>
                                                    </div>
                                                    <div className="content">
                                                        <h5>Customer Support</h5>
                                                        <p>Simply amazing support... TOP Seller in terms of support...
                                                            Thanks a
                                                            lot... I will keep buying your products... amazing work... bug
                                                            free...
                                                            thanks a lot...</p>
                                                        <div className="rating">
                                                            <img src="assets/images/icons/rating.png" alt="Rating Images" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </Slider>
                                </div>
                            </div>
                        </div>
                    </div>           */}


                    {/* Start Footer Area  */}
                    {/* <footer className="call-to-action-wrapper text-white-wrapper call-to-action bg-theme-gradient ptb--120 with-particles">
                        <div className="frame-layout__particles">
                            <Particles className="particle"
                                options={{
                                    style:{
                                        position: "absolute"
                                    },
                                    fpsLimit: 100,
                                    interactivity: {
                                    detectsOn: "canvas",
                                    events: {
                                        onClick: {
                                        enable: true,
                                        mode: "push",
                                        },
                                        onHover: {
                                        enable: true,
                                        mode: "repulse",
                                        },
                                        resize: true,
                                    },
                                    modes: {
                                        bubble: {
                                            distance: 100,
                                            duration: 2,
                                            opacity: 0.8,
                                            size: 10,
                                            color: "#ffffff",
                                        },
                                        push: {
                                        quantity: 4,
                                        },
                                        repulse: {
                                            distance: 100,
                                            duration: 0.4,
                                            color: "#ffffff",
                                        },
                                    },
                                    },
                                    particles: {
                                    color: {
                                        value: "#ffffff",
                                    },
                                    links: {
                                        color: "#ffffff",
                                        distance: 150,
                                        enable: true,
                                        opacity: 0.5,
                                        width: 1,
                                    },
                                    collisions: {
                                        enable: true,
                                    },
                                    move: {
                                        direction: "none",
                                        enable: true,
                                        outMode: "bounce",
                                        random: false,
                                        speed: 6,
                                        straight: false,
                                       
                                    },
                                    number: {
                                        density: {
                                            enable: true,
                                            value_area: 2000,
                                        },
                                        value: 80,
                                    },
                                    opacity: {
                                        value: 0.5,
                                    },
                                    shape: {
                                        type: "circle",
                                    },
                                    size: {
                                        random: true,
                                        value: 5,
                                    },
                                    },
                                    detectRetina: true,
                                }}
                            />
                        </div>
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="inner text-center">
                                        <span>{t.demo.footer.agency}</span>
                                        <h2>{t.demo.footer.title}</h2>
                                        <a className="rn-button-style--2" target="_blank" href="contact"><span>{t.demo.footer.contactButton}</span></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </footer> */}
                    {/* End Footer Area  */}
                </div>
                {/* End Preview Main Wrapper */}

                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}

                <Footer />
            </div>
        )
    }

